import styled, { css } from "styled-components";

const Poster = () => css`
  height: 100%;
  position: relative;
  display: ${({ show, christmasTheme }) =>
    show ? (christmasTheme ? "" : "absolute") : "none"};
  background-image: ${({ posterUrl, christmasTheme }) =>
    christmasTheme ? "none" : "url(" + posterUrl + ")"};
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: ${({ theme }) => (theme == "vivaTheme" ? "1" : "0.5")};
`;

export default styled.div([Poster]);
